/* eslint-disable */
import './polyfills';
import Vue from 'vue';
import Vuex from 'vuex';
import vuexI18n from 'vuex-i18n';

import { MuiNotificationPlugin } from '@ubeeqo/motion-ui/lib/components/common/MuiNotification';
import { MuiModalPlugin } from '@ubeeqo/motion-ui/lib/components/common/MuiModal';

import { Geolocation } from './services';
import publicPaths from './utils/publicPaths';
import flavor from './flavors';
import Setup from './utils/Setup';

Vue.use(Vuex);
Vue.use(MuiNotificationPlugin);
Vue.use(MuiModalPlugin);

export const store = require('./store').default;

import App from './App';
import PhoenixCore from '../core';

Vue.config.productionTip = false;
const AuthService = PhoenixCore.authService;

export let Auth = null;

async function setupAuth(ENV, router, store) {
  Auth = new AuthService({
    domain: ENV.auth.domain,
    clientID: ENV.auth.clientID,
    redirectUri: `${window.location.origin}/authenticating`,
    audience: ENV.auth.audience,
    responseType: ENV.auth.responseType,
    scope: ENV.auth.scope,
    store,
    ENV,
    router,
  });

  const {
    authenticated
  } = await Auth.handleAuthentication();
  return authenticated;
}

async function startApp(clientConfig, store, router) {
  const {
    env: ENV,
  } = clientConfig;
  // Require Login for non-public routes.
  router.beforeEach(async (to, from, next) => {
    const canAccess = publicPaths.some(p => new RegExp(p).test(to.path));
    if (!canAccess && !Auth.isAuthenticated()) {
      Auth.logout();
    } else {
      next();
    }
  });

  store.commit('Setup/updateSetup', clientConfig);
  Vue.use(vuexI18n.plugin, store);

  Setup.initAxiosClientConfig(ENV);
  Setup.setupTitle(clientConfig);
  Setup.setupGoogleMaps(ENV);
  Setup.setupSegment(ENV, '4.1.0');

  const gmapApi = await Vue.$gmapApiPromiseLazy();
  Geolocation.create({
    gmapApi,
  });

  await setupAuth(ENV, router, store);
  await Setup.setupTemplateLanguages(clientConfig);
  Setup.setupAlgolia(ENV, Auth);

  new Vue({
    store,
    router,
    render: h => h(App),
  }).$mount('#app');
}

async function loadConfig() {
  const data = await Setup.loadEnvConfig();

  flavor({
    flavor: data.flavor,
    domain: data.domain,
    store,
  }).then((configData) => {
    const promiseConfigData = configData.reduce((a, b) => ({ ...a, ...b}), {});

    startApp(data, promiseConfigData.store, promiseConfigData.router);
  });
}

// Init the App
loadConfig();
